import { fallbackFontValue } from 'js/shared/resources/scribedefaults';

export default function getFontFamilyWithFallbackString(font) {
  return `"${font}", "${fallbackFontValue}"`;
}
